var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.styling,attrs:{"data-bs-toggle":"modal","data-bs-target":_vm.target},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }